export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const ERROR_TOKEN = 'errorToken';
export const EMAIL = 'email';
export const USERNAME = 'username';
export const LANGUAGE = 'language';
export const I18N = 'i18next';
